
import { defineComponent, PropType, ref, computed, watch } from 'vue'
import { FieldStructure } from '@/contracts/forms/FieldContracts'

export default defineComponent(
{
    name: 'Input',
    emits: ['inputValueUpdated'],
    props:
    {
        field:
        {
            type: Object as PropType<FieldStructure>,
            default: {} as FieldStructure
        }
    },
    setup(props, { emit })
    {
        const inputValue = ref(props.field.value)
        const inputDay = ref()
        const inputMonth = ref()
        const inputYear = ref()

        const fieldGroupId = computed(() =>
        {
            return props.field.name + '-field-group'
        })

        const hintId = computed(() =>
        {
            return props.field.name + '-hint'
        })

        const errorId = computed(() =>
        {
            return props.field.name + '-error'
        })

        const fieldGroupClassList = computed(() =>
        {
            return {
                'govuk-form-group': true,
                'govuk-form-group--error': props.field.errors !== undefined
            }
        })

        const inputClassList = function(size: number)
        {
            const sizeClass = 'govuk-input--width-' + size
            return 'govuk-input govuk-date-input__input ' + sizeClass + (props.field.errors !== undefined ? ' govuk-input--error' : '')
        }

        const inputDescribedBy = computed(() =>
        {
            let inputDescribedByString = ''
            inputDescribedByString += (props.field.hint !== undefined ? hintId.value + ' ' : '')
            inputDescribedByString += (props.field.errors !== undefined ? errorId.value + ' ' : '')
            return inputDescribedByString
        })

        const getInputId = function(type: string)
        {
            return props.field.name + '-' + type
        }

        watch(inputDay, (newValue) => updateInputValue())
        watch(inputMonth, (newValue) => updateInputValue())
        watch(inputYear, (newValue) => updateInputValue())
        const updateInputValue = function()
        {
            const day = inputDay.value
            const month = inputMonth.value
            const year = inputYear.value
            const date = day + '/' + month + '/' + year
            inputValue.value = date
        }

        watch(inputValue, (inputValue) => emit('inputValueUpdated',
        {
            name: props.field.name,
            value: inputValue
        }))

        // Return data:
        return {
            inputValue,
            inputDay,
            inputMonth,
            inputYear,
            fieldGroupId,
            hintId,
            errorId,
            fieldGroupClassList,
            inputClassList,
            inputDescribedBy,
            getInputId
        }
    }
})
